import Screw from "@scene/objects/screw/screw";
import { initState as initDimensionState } from "@reducers/selectors/dimension";
import { APP_TYPES } from "@config";
import { ScrewGroup } from "@scene/objects/screw";

export default {
  count: {
    n: initDimensionState[APP_TYPES.WOOD_CONNECTION].anchorsConfiguration.n,
    m: 1
  },
  custom: {
    allow: false, // If user select n type screws
    active: initDimensionState[APP_TYPES.WOOD_CONNECTION].anchorsConfiguration.isCoordinatesEnabled, // If user select specify coordinated
    positions: initDimensionState[APP_TYPES.WOOD_CONNECTION].anchorsConfiguration.coordinates // Container screws positions
  },
  padding: {
    s1: 15,
    s2: 0
  },
  types: [],
  heightType: Screw.types.height.DEFAULT,
  coordinatesList: [], // Contain screw coordinates
  radius: initDimensionState[APP_TYPES.WOOD_CONNECTION].anchorsConfiguration.diameter / 2,
  formation: ScrewGroup.formation.FILLED_SQUARE,
};



// WEBPACK FOOTER //
// ./src/reducers/options/screw/defaults/woodConnection.js